// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__7SdSh","tabs":"Tabs_tabs__2kaCa"};